function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { logger } from '@src/logger';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { getWindow } from '@shared/services/window';
import { Constants } from './constants';
import { stringifyError } from './errorUtils';
export function getSignUpHost({ modalType, isConverged }) {
    if (modalType === Constants.SignInType.SignInWith_MSA || modalType === Constants.SignInType.SwitchTo_MSA) {
        return 'https://signup.live.com/signup?wa=wsignin1.0&rpsnv=13&rver=6.7.6643.0&wp=MBI_SSL';
    }
    return `https://signup.microsoft.com/signUp?sku=${isConverged ? 'marketplace' : 'appsource'}`;
}
export function getSignInHeader(context) {
    return context.loc('SI_SignInAppSource');
}
export function getTitle(context) {
    return context.loc('SI_WorkAccount');
}
export function getRedirectString(modalType) {
    if (modalType === Constants.SignInType.SignInWith_MSA || modalType === Constants.SignInType.SwitchTo_MSA) {
        return '&wreply=';
    }
    return '&ru=';
}
export function handleSignUp() {
    return _async_to_generator(function*() {
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.Signup,
            details: JSON.stringify({
                message: 'Clicked on sign-up. Navigating to office portal'
            })
        };
        SpzaInstrumentService.getProvider().probe('logAndFlushTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
        try {
            const redirectUrl = `https://signup.microsoft.com/signUp?sku=appsource&ru=${encodeURIComponent(getWindow().location.href)}&pi=1`;
            getWindow().location.href = redirectUrl;
        } catch (err) {
            const payload = {
                page: getWindow().location.href,
                action: Constants.Telemetry.Action.Login,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                details: stringifyError(err)
            };
            SpzaInstrumentService.getProvider().probe(Constants.Telemetry.ProbeName.LogInfo, payload);
            logger.error(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
        }
    })();
}
